/* eslint-disable jsx-quotes */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable comma-dangle */
import './RedirectPage.css';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { RedirectToLogin } from '../util/cookies';

function RedirectPage({ handleLogin }) {
  const navigate = useNavigate();
  const { instance, inProgress } = useMsal();
  const [isHandled, setIsHandled] = useState(false);

  const sendTokenToBackend = async (accessToken) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_WO_BACKEND_URL}/chat_bot_rasa/be/token_auth/`,
        { access_token: accessToken },
        { withCredentials: true }
      );
      if (response.data.status === 'success') {
        handleLogin();
        navigate('/chat');
      } else {
        const errorMessage = response.data.message || 'Authentication failed. Please try again.';
        setTimeout(() => {
          alert(errorMessage);
          RedirectToLogin(navigate);
        }, 0);
      }
    } catch (error) {
      let errorMessage = 'Authentication failed. Please try again or contact administrator.';

      // Check if it's a 404 error with user role not found message
      if (error.response && error.response.status === 404) {
        errorMessage = error.response.data?.message || 'User role not found. Please contact administrator.';
      } else if (error.response && error.response.data?.message) {
        errorMessage = error.response.data.message;
      }

      setTimeout(() => {
        alert(errorMessage);
        RedirectToLogin(navigate);
      }, 0);
    }
  };
  useEffect(() => {
    const getToken = async () => {
      // Wait for MSAL to be ready (no interaction in progress)
      if (inProgress !== InteractionStatus.None || isHandled) {
        return;
      }
      try {
        // Handle the redirect response
        const response = await instance.handleRedirectPromise();
        setIsHandled(true);
        if (response && response.accessToken) {
          await sendTokenToBackend(response.accessToken);
        } else {
          console.log('No redirect response found - redirecting to login');
          setTimeout(() => {
            alert('Session expired or invalid. Please login again.');
            RedirectToLogin(navigate);
          }, 0);
        }
      } catch (error) {
        setIsHandled(true);
        console.error('Error handling redirect:', error);
        setTimeout(() => {
          alert('Authentication error. Please try logging in again.');
          RedirectToLogin(navigate);
        }, 0);
      }
    };
    getToken();
  }, [inProgress, isHandled]);

  return (
    <div className='loader-container-ani'>
      <div className='lds-roller'>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}
RedirectPage.propTypes = {
  handleLogin: PropTypes.func.isRequired,
};

export default RedirectPage;
